import React from 'react';
import {StaticRouter, Route, useLocation} from 'react-router-dom';
import IndexSkeleton from '../IndexSkeleton';
import {routesResources} from '../../utils/uiconstants';
import {getTheme} from '@ey/styled-theme';
import styled, {ThemeProvider} from 'styled-components';
import {getTheme as utilsGetTheme} from '../../utils/utils';

function LoaderContainer(props) {
	const {isLoading, children, context, path} = props;

	const theme = utilsGetTheme();

	return (
		<ThemeProvider theme={getTheme(theme)}>
			<StyledAppContainer>
				{isLoading ? (
					<StaticRouter location={path || '/'} context={context}>
						<Route path="/" render={IndexSkeleton} exact />
						<Route
							path={`/${routesResources.admin}/:cardId?/:partitionKey?`}
							render={IndexSkeleton}
						/>
						<Route path="/projectSummary" render={IndexSkeleton} />
					</StaticRouter>
				) : (
					children
				)}
			</StyledAppContainer>
		</ThemeProvider>
	);
}

export default LoaderContainer;

const StyledAppContainer = styled.section`
	background: ${(props) => props.theme.color[`grey50`]};
	height: 100%;
	overflow: hidden;
	.react-loading-skeleton {
		background-color: ${(props) => props.theme.color[`grey200`]};
		background-image: ${(props) => props.theme.color[`grey100`]};
		background-size: 200px 100%;
		display: inline-block;
		line-height: 1;
		width: 100%;
		background-repeat: no-repeat;
		border-radius: 4px;
		animation: 1.2s ease-in-out 0s infinite normal none running
			animation-16jpnkj;
	}
	.fetch-loader {
		.motif-loader-container {
			z-index: 999;
			background-color: ${(props) => props.theme.color[`grey50`]};
		}
	}
`;
